export const eventCrop = { width: 320, height: 180 };
export const organizerCrop = { width: 327, height: 327 };
export const searchCrop = { width: 60, height: 45 };
